module.exports = __webpack_public_path__ + "static/devopsbay-07546d378bdcbce56d083b98c94cded9.png";